import React from 'react';
import Tilt from 'react-tilt'
import './logo.css';
const Logo = () =>{
    return(
        <div className="ma4 mt0">
            <Tilt className="Tilt" options={{ max : 55 }} style={{ height: 150, width: 150 }} >
                <div className="Tilt-inner pa3">
                    <img src="https://img.icons8.com/pastel-glyph/142/000000/brain.png"/>
                </div>
            </Tilt>
        </div>
    )
}

export default Logo;